export default __webpack_public_path__ + "static/media/007-line.ec79a432.svg";